import { render } from "./bindEmail.vue?vue&type=template&id=29bb64c0"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__